module.exports = __webpack_public_path__ + "static/media/snowmobile.6de89c82.svg";